/**
 * Text utility functions for consistent formatting across the application
 */

/**
 * Converts text to uppercase for display purposes
 * @param {string} text - The text to convert
 * @returns {string} The uppercase version of the text
 */
export const toUpperCase = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  return text.toUpperCase();
};

/**
 * Converts text to uppercase while preserving original formatting for form inputs
 * This is useful when you want to display uppercase but keep original data
 * @param {string} text - The text to convert
 * @returns {string} The uppercase version of the text
 */
export const displayUpperCase = (text) => {
  return toUpperCase(text);
};